<template>
  <div class="container py-6">
    <p class="text-center text-sm text-gray-400 mb-4 tracking-wide uppercase">Filter</p>
    <div class="flex flex-wrap justify-center gap-2">
      <button
        v-for="tag in tags"
        :key="tag.id"
        @click="toggle_tag(tag.id)"
        class="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border"
        :class="active_tag(tag.id)
          ? 'bg-gray-900 text-white border-gray-900 shadow-sm'
          : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400 hover:text-gray-900'"
      >
        {{ tag.title }}
        <svg v-if="active_tag(tag.id)" xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useVideoStore } from '../stores'

export default {
  computed: {
    ...mapState(useVideoStore, ['tags', 'active_tags', 'active_tag'])
  },
  methods: {
    ...mapActions(useVideoStore, ['toggle_tag'])
  }
}
</script>
